import React, { useEffect, useState } from 'react';
import { isAuthenticated, redirectIfNotAuthenticated } from '../utils/auth';

const AuthWrapper = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const checkAuth = () => {
      const authenticated = isAuthenticated();
      setIsAuth(authenticated);
      
      if (!authenticated) {
        redirectIfNotAuthenticated();
      } else {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        جاري التحقق من الصلاحيات...
      </div>
    );
  }

  if (!isAuth) {
    return null; // Will redirect to signin
  }

  return children;
};

export default AuthWrapper;
